// Script de diagnóstico completo para categorías
export {};

(window as any).diagnoseCategoryIssue = async function() {
  console.log('🔍 DIAGNÓSTICO COMPLETO DE CATEGORÍAS');
  console.log('=====================================');
  
  try {
    // 1. Verificar Firebase
    if (!(window as any).auth) {
      console.error('❌ Firebase no está disponible');
      return;
    }
    console.log('✅ Firebase disponible');

    // 2. Verificar usuario autenticado
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      console.error('❌ Usuario no autenticado');
      return;
    }
    console.log(`✅ Usuario autenticado: ${userId}`);

    // 3. Verificar servicios
    const { db, collection, getDocs, query, orderBy } = (window as any).auth;
    console.log('✅ Servicios Firebase disponibles');

    // 4. Verificar categorías existentes
    console.log('\n📂 Verificando categorías existentes...');
    const categoriesRef = collection(db, 'users', userId, 'categories');
    const snapshot = await getDocs(categoriesRef);
    
    console.log(`📊 Total de documentos en categories: ${snapshot.size}`);
    
    if (snapshot.size === 0) {
      console.log('⚠️ NO HAY CATEGORÍAS EN FIRESTORE');
      console.log('💡 Ejecuta: window.fixCategories() para crear las categorías correctas');
      return;
    }

    // 5. Mostrar categorías existentes
    console.log('\n📋 Categorías encontradas:');
    snapshot.forEach((doc: any) => {
      const data = doc.data();
      console.log(`  - ID: "${doc.id}"`);
      console.log(`    Nombre: "${data.name || 'Sin nombre'}"`);
      console.log(`    Habilitada: ${data.enabled !== false ? 'SÍ' : 'NO'}`);
      console.log(`    Campos: ${Object.keys(data.fields || {}).length}`);
      console.log('');
    });

    // 6. Probar servicio optimizado
    console.log('🔧 Probando servicio optimizado...');
    try {
      const optimizedService = (await import('../services/optimizedInventoryService')).default;
      const categories = await optimizedService.getCategories();
      console.log(`✅ Servicio optimizado funciona: ${categories.length} categorías`);
      
      if (categories.length > 0) {
        console.log('📋 Categorías del servicio:');
        categories.forEach(cat => {
          console.log(`  - ${cat.name} (ID: ${cat.id}) - Habilitada: ${cat.enabled !== false ? 'SÍ' : 'NO'}`);
        });
      }
    } catch (error) {
      console.error('❌ Error con servicio optimizado:', error);
    }

    // 7. Probar toggle de categoría
    console.log('\n🔄 Probando toggle de categoría...');
    if (snapshot.size > 0) {
      const firstDoc = snapshot.docs[0];
      const categoryName = firstDoc.data().name || firstDoc.id;
      
      try {
        const optimizedService = (await import('../services/optimizedInventoryService')).default;
        
        console.log(`🧪 Probando toggle de "${categoryName}"...`);
        const currentState = firstDoc.data().enabled !== false;
        console.log(`Estado actual: ${currentState ? 'Habilitada' : 'Deshabilitada'}`);
        
        // Intentar cambiar estado
        await optimizedService.updateCategory(categoryName, { enabled: !currentState });
        console.log(`✅ Toggle exitoso: ${!currentState ? 'Habilitada' : 'Deshabilitada'}`);
        
        // Verificar cambio
        const updatedCategories = await optimizedService.getCategories();
        const updatedCategory = updatedCategories.find(cat => cat.name === categoryName);
        console.log(`Estado verificado: ${updatedCategory?.enabled !== false ? 'Habilitada' : 'Deshabilitada'}`);
        
        // Restaurar estado original
        await optimizedService.updateCategory(categoryName, { enabled: currentState });
        console.log(`🔄 Estado restaurado a: ${currentState ? 'Habilitada' : 'Deshabilitada'}`);
        
      } catch (error) {
        console.error('❌ Error en toggle:', error);
      }
    }

    console.log('\n🎯 DIAGNÓSTICO COMPLETADO');
    console.log('Si las categorías no se pueden habilitar/deshabilitar:');
    console.log('1. Ejecuta: window.fixCategories()');
    console.log('2. Verifica que el modal use optimizedInventoryService');
    console.log('3. Revisa la consola del navegador para errores');

  } catch (error) {
    console.error('❌ Error en diagnóstico:', error);
  }
};

console.log('🔧 Script de diagnóstico cargado');
console.log('💡 Usa: window.diagnoseCategoryIssue()');
